<div id="browsingHeader" [ngClass]="{ 'pb-0': (featuredCollections$ | async)?.length }">
    <div class="container">
        <div>
            <div id="summary" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pb-lg-8 pb-xs-4">
                <ng-container *ngIf="showBreadcrumb">
                    <app-breadcrumbs></app-breadcrumbs>
                </ng-container>
                <div class="header">
                    <img
                        *ngIf="node.parents.length"
                        src="{{ node.posterImage }}"
                        alt="{{ node.posterImageAltText }}"
                    />

                    <h1 class="title selenium-subject-title" [ngStyle]="{ color: backgroundColor }">
                        {{ node.title }}
                    </h1>
                </div>
                <div class="description selenium-subject-description mt-6">
                    {{ node.description }}
                </div>
            </div>
            <app-featured-collections-browse
                *ngIf="(featuredCollections$ | async)?.length === 2"
                [featuredCollections]="featuredCollections$ | async"
                [collectionTitle]="node.title"
                class="featured-collections px-xs-4 px-md-0"
            >
            </app-featured-collections-browse>
        </div>
    </div>
</div>
